var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gender-radio" },
    [
      _c("div", { staticClass: "md-subheading" }, [_vm._v("Gender")]),
      _vm._l(_vm.genders, function(gender) {
        return _c(
          "md-radio",
          {
            key: gender,
            staticClass: "md-primary",
            attrs: { "md-value": gender.key },
            on: { change: _vm.onGenderChange },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          },
          [_vm._v(_vm._s(gender.value))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03976cd4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03976cd4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/demographic/GenderRadio.vue
// module id = 920
// module chunks = 0